<template>
  <div class="integrity">
    <div class="d-flex justify-content-end">
      <button :disabled="isUpdating" class="ui-action-button" @click="save">
        {{ $t('global.saveChanges') }}
        <b-spinner class="ml-1" small label="loading" v-if="isUpdating"></b-spinner>
      </button>
    </div>

    <div class="integrity__form">
      <div class="input-container">
        <label class="text-black">{{ $t("integrityCompliance.integrity.form_title") }} (*)</label>
        <input type="text" id="title" name="title" v-model="category.title" />
        <div class="ui-input-error-msg">
          <span v-if="$v.category.title.$error">{{ $t("global.inputs.required") }}</span>
        </div>
      </div>

      <div class="wysiwyg-container">
        <label class="text-black">{{ $t("integrityCompliance.complice.module_introduction") }}</label>
        <div class="wysiwyg">
          <Wysiwyg id="integrityDescription" ref="integrityDescription" :articleBody="category.originalDescription"
            :placeholder="$t('integrityCompliance.integrity.form_write_content')" :includeMediaContent="false"
            v-on:updateBody="category.description = $event"></Wysiwyg>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
const Wysiwyg = () => import("@/components/Wysiwyg");
import { required } from "vuelidate/lib/validators";
import { validateBody } from '@/lib/utils.js'
import { integrityComplianceKey } from "@/lib/constants.js";
import API_SERVICE from "@/lib/api/IntegrityCompliance.js";
const api = new API_SERVICE();

export default {
  inject: ['IC_getMainCategory'],
  components: {
    Wysiwyg
  },
  mounted() {
    this.getCategory();
  },

  data: function () {
    return {
      isUpdating: false,
      category: {
        id: null,
        name: '',
        title: '',
        description: {
          ops: []
        },
        originalDescription: {
          ops: []
        }
      }
    }
  },
  validations: {
    category: {
      title: {
        required
      },
      description: {
        isRequired: function (data) {
          return validateBody(data)
        }
      },
    }
  },
  methods: {
    save() {
      this.category.title = this.category.title.trim();
      this.$v.$touch();
      if (this.$v.$error) return;
      this.saveCategory();
    },
    async saveCategory() {
      try {
        this.isUpdating = true;
        const params = {
          name: integrityComplianceKey.compliance,
          title: this.category.title,
          description: this.category.description
        }
        const response = await api.updateCategory(this.category.id, params);
        this.$emit('categoryUpdated', {
          id: this.category.id,
          ...response
        });
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('global.successSaved'),
          show: true,
          type: "success"
        });
      } catch (error) {
        console.error(error);
        this.$store.commit("global/SET_ALERT", {
          msg: this.$t('integrityCompliance.integrity.error_intro'),
          show: true,
          type: "error"
        });
      } finally {
        this.isUpdating = false;
      }
    },
    getCategory() {
      const category = this.IC_getMainCategory();
      this.category = { ...category };
      this.category.originalDescription = category.description;
    }
  }
}
</script>

<style lang="scss" scoped>
.integrity {
  width: 100%;

  &__form {
    margin-top: $global_padding;

    .input-container {
      width: 35%;
    }

    .wysiwyg-container {
      margin-top: $global_padding * 3;
    }
  }
}
</style>
